import React from 'react';
import Backend from '../../Layouts/Backend';
import { withTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import helper from '../../../utils/helper';

function MItem({ path, t, label }) {
  return (
    <div>
      <NavLink to={path} className="configure-item">
        {t(label)}
      </NavLink>
    </div>
  );
}
const MenuItem = withTranslation('app')(MItem);
export default () => (
  <Backend>
    <div className="content-inner">
      {helper.checkPermission('API.Department') && (
        <MenuItem
          path="/configure/departments/new-department"
          label="Create Department"
        />
      )}
      {helper.checkPermission('API.GroupSetting') && (
        <MenuItem path="/configure/groups/new-group" label="Create Group" />
      )}
      {helper.checkPermission('AbpIdentity.Roles') && (
        <MenuItem path="/configure/roles/new-role" label="Create Role" />
      )}
      {helper.checkPermission('API.Units') && (
        <MenuItem path="/configure/units/new-unit" label="Create Unit" />
      )}
      {helper.checkPermission('API.Users') && (
        <MenuItem path="/configure/users/new-user" label="Create User" />
      )}
      {helper.checkPermission('API.RemoteStations') && (
        <MenuItem
          path="/configure/remote-devices/new-remote-device"
          label="Create Remote Device"
        />
      )}
    </div>
  </Backend>
);
